<template>
  <div
    v-if="selected && selected.length > 0"
    :style="style_"
    class="select-collapse-popup flexC"
  >
    <!-- 展示的选项和按钮 -->
    <el-tag
      v-for="(item, i) in selected_"
      :key="i"
      :closable="!$parent.selectDisabled"
      size="small"
      type="info"
      disable-transitions
      @close="deleteTag($event, item)"
    >
      <span class="el-select__tags-text">{{ item.currentLabel }}</span>
    </el-tag>
    <el-tag
      v-if="btnFlag_"
      ref="tagsBtn"
      v-clickoutside="closePopover"
      :closable="false"
      size="small"
      type="info"
      disable-transitions
      class="shrink-0 more-tag pointer"
      :class="{ active: visible, disabled: $parent.selectDisabled }"
      @click.native.stop="handleMore"
    >
      <span class="el-select__tags-text">
        <template
v-if="tagsNumber"
          >+ {{ selected.length - showIndex - 1 }}</template
        >
        <i v-else class="el-icon-more" style="margin-left: 0" />
      </span>
    </el-tag>
    <!-- 这部分内容用于获取tag的宽度，以下展示的方式和样式要和上面的tag一样（这部分内容是隐藏的） -->
    <div class="collapse-tags-hidden">
      <el-tag
        v-for="item in selected"
        ref="hiddenTags"
        :key="item.currentLabel"
        :closable="!$parent.selectDisabled"
        size="small"
        type="info"
        disable-transitions
      >
        <span class="el-select__tags-text">{{ item.currentLabel }}</span>
      </el-tag>
      <el-tag
        ref="hiddenTagsBtn"
        key="..."
        :closable="false"
        size="small"
        type="info"
        disable-transitions
        class="shrink-0 more-tag pointer"
        :class="{ active: visible }"
        @click.native.stop="handleMore"
      >
        <span class="el-select__tags-text">
          <template
v-if="tagsNumber"
            >+ {{ selected.length - showIndex - 1 }}</template
          >
          <i v-else class="el-icon-more" style="margin-left: 0" />
        </span>
      </el-tag>
    </div>
    <!-- 弹窗 -->
    <el-popover
      ref="elPopover"
      v-model="visible_"
      placement="bottom"
      :reference="referenceEl"
      :width="popoverWidth"
      :visible-arrow="false"
      trigger="manual"
      popper-class="cnd-select-popover"
    >
      <div ref="popover" class="el-select">
        <div class="el-select__tags">
          <el-tag
            v-for="item in selected"
            :key="item.currentLabel"
            :closable="!$parent.selectDisabled"
            size="small"
            type="info"
            disable-transitions
            @close="deleteTag($event, item)"
          >
            <div class="tags-view">
              <div class="el-select__tags-text">{{ item.currentLabel }}</div>
            </div>
          </el-tag>
        </div>
      </div>
    </el-popover>
  </div>
</template>

<script>
import Clickoutside from 'element-ui/src/utils/clickoutside'
import ElSelectMenu from '../src/select-dropdown'

import { Tag, Popover } from 'element-ui'

export default {
  // element 的用于判断是否点点击了其他元素
  directives: { Clickoutside },
  components: { ElSelectMenu, ElTag: Tag, ElPopover: Popover },
  props: {
    // 已选中的标签数据
    selected: {
      type: Array,
      default() {
        return []
      }
    },
    filterable: {
      type: Boolean,
      default: false
    },
    // 弹窗模式下展示更多按钮是否显示数字
    tagsNumber: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: false,
      popoverWidth: 0,
      popperElm: null,
      referenceEl: null,
      sizeRecord: {},
      showIndex: 0,
      btnFlag: false
    }
  },
  computed: {
    visible_: {
      get() {
        return this.visible && this.selected && this.selected.length > 1
      },
      set(v) {
        this.visible = v
      }
    },
    selected_() {
      return this.selected.slice(0, this.showIndex + 1)
    },
    btnFlag_() {
      return this.selected.length > 1 && this.btnFlag
    },
    style_() {
      return {
        maxWidth: this.filterable ? 'calc(100% - 36px)' : '100%'
      }
    }
  },
  watch: {
    selected: {
      immediate: true,
      handler() {
        this.$nextTick(() => {
          this.updataIndex()
        })
      }
    },
    '$parent.inputWidth'() {
      this.$nextTick(() => {
        this.updataIndex()
      })
    }
  },
  mounted() {
    // 弹出框宽度
    this.referenceEl = this.$parent.$refs.reference.$el
    this.$nextTick(() => {})
  },
  methods: {
    handleMore() {
      this.popoverWidth = this.$parent.$el.getBoundingClientRect().width
      this.$parent.handleClose()
      this.visible = !this.visible
      this.$nextTick(() => {
        this.popperElm = this.$refs.popover
      })
    },
    deleteTag(event, tag) {
      this.$parent.deleteTag(event, tag)
      this.$refs.elPopover.updatePopper()
    },
    closePopover() {
      this.visible = false
    },
    updataIndex() {
      if (!this.selected || this.selected.length <= 1) {
        this.showIndex = 0
        return
      }
      let index = -1
      let maxWidth = this.$parent.$refs.tags?.clientWidth || 0
      maxWidth = this.filterable ? maxWidth - 36 : maxWidth
      let hiddenTags = this.$refs.hiddenTags || []
      hiddenTags = [...hiddenTags, this.$refs.hiddenTagsBtn]
      hiddenTags.forEach((r, i) => {
        const key = r.$vnode.key
        if (!this.sizeRecord[key]) {
          const e = r.$el
          // 获取marginLeft的值
          const marginLeft = getComputedStyle(e).marginLeft
          const width = e.offsetWidth + parseFloat(marginLeft)
          this.sizeRecord[key] = width
        }
      })
      const btnWidth = this.sizeRecord['...']
      const length = this.selected.length
      this.btnFlag = true
      this.selected.forEach((v, i) => {
        const width = this.sizeRecord[v.currentLabel] || 0
        maxWidth -= width
        if (i === 0) {
          index++
        } else if (maxWidth >= 0 && i === length - 1) {
          index++
          this.btnFlag = false
        } else if (maxWidth >= 0 && maxWidth - btnWidth >= 0) {
          index++
        }
      })
      this.showIndex = index
    }
  }
}
</script>
